// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@conklin/XDL/types";
import { color } from "@conklin/XDL/Utilities";
import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            formInputWrapper: css`
                [role="combobox"] {
                    z-index: 1;
                }
                ${IconWrapper} {
                    justify-content: flex-end;
                    width: auto;
                }
            `,
            list: css`
                border: 1px solid ${color("common.ui5")};
                width: 100%;
            `,
            dropdownWrapper: css`
                && input {
                    ~ ${IconWrapper} {
                        justify-content: center;
                        transform: rotate(90deg);
                    }

                    &[aria-expanded="true"] {
                        ~ ${IconWrapper} {
                            transform: rotate(-90deg);
                        }
                    }
                }
            `,
        },
    },
} as xBaseTheme["dynamicDropdown"];
